define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var Campaigns = require('web-agent-assets-js/lpCampaigns');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');

    lpTag.lpCampaignsController = function (model, config) {
        this.applicationType = "lpCampaignsController";
        var logger = WebAgentLogger.getLogger(this.applicationType);

        var campaignsApi, getLob, lobContext;

        if (config) {
            getLob = config.getLob;
            lobContext = config.lobContext;
        }

        this.getCampaign = function (data) {
            getCampaign(data);
        };

        this.getSingleCampaignObject = function (campaignObject, name) {
            return getSingleCampaignObject(campaignObject, name);
        };
        initializeApi();

        function initializeApi() {
            campaignsApi = new Campaigns();
        }

        /////////////////////////////// CAMPAIGN DATA ///////////////////////////////////

        function getCampaign(data) {
            logger.info("","getCampaign", data);
            var id;
            if (data) {
                id = data.id;
            }
            if (id) {
                var requestObj = {
                    success: lpUtils.callbackContextWrapper(handleCampaignsSuccess, data),
                    error: lpUtils.callbackContextWrapper(handleCampaignsError, data),
                    context: data
                };
                campaignsApi.getCampaign(requestObj, id);
            }
        }

        function handleCampaignsSuccess(data) {
            logger.info("Campaigns return as Success", "handleCampaignsSuccess");
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpTag.lpCampaignsController.prototype.handleACRequestSuccess(model, data, lpTag.lpCampaignsController.prototype.serviceNames.campaigns, getSingleCampaignObject, context, dataObject);
        }

        function handleCampaignsError(data) {
            logger.error("", 'handleCampaignsError', data);
            logger.graph({name: 'handleCampaignsError'});
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpTag.lpCampaignsController.prototype.handleRequestError(model, data, lpTag.lpCampaignsController.prototype.serviceNames.campaigns, data && data.visitorId, dataObject);
        }

        function getSingleCampaignObject(campaignObject, name) {
            var toReturn = lpTag.lpCampaignsController.prototype.getDataFromModelIfNotModified(model, this, name) || {
                    id: campaignObject.id,
                    name: campaignObject.name,
//            status: campaignObject.status,
//            priority: campaignObject.priority,
//            weight: campaignObject.weight,
            goalId: campaignObject.goalId,
            lobId: campaignObject.lobId,
            description : campaignObject.description,
            _visitorProfileId: campaignObject._visitorProfileId || (campaignObject.visitorProfiles && campaignObject.visitorProfiles[0])};
            var visitorId = campaignObject.visitorId || (campaignObject.dataObject && campaignObject.dataObject.data && campaignObject.dataObject.data.visitorId);
            if (getLob && toReturn.lobId) {
                lpTag.lpCampaignsController.prototype.addServiceToRequestedServices(lpTag.lpCampaignsController.prototype.serviceNames.lob, campaignObject.dataObject, model);
                getLob.call(lobContext || {}, {id: toReturn.lobId, visitorId:visitorId, dataObject:campaignObject.dataObject});
                lpTag.lpCampaignsController.prototype.addDataObjectToVisitorInfo(model, {visitorId: visitorId, lob:{id: toReturn.lobId}}, undefined, campaignObject.dataObject);
            }
            lpTag.lpCampaignsController.prototype.addToVisitorInfoById(model, 'campaign', toReturn, visitorId, campaignObject && campaignObject.dataObject, lpTag.lpCampaignsController.prototype.serviceNames.campaigns);
            return toReturn;
        }
    };
    lpTag.lpCampaignsController.prototype = new lpBaseInfoController();

    return lpTag.lpCampaignsController;
});
